import React, { Component } from 'react';
import Loading from 'react-loading-bar';
import { connect } from 'react-redux';
import 'react-loading-bar/dist/index.css';
import {default as LoaderCustom} from 'react-loader'
import './style.scss';

class Loader extends Component {
  render = () => (
    <LoaderCustom
      loaded={!(this.props.loading || this.props.forcingLoad)}
      className="spinner"
      options={{
        lines: 13,
        length: 20,
        width: 10,
        radius: 30,
        scale: 1.00,
        corners: 1,
        color: '#007b91',
        opacity: 0.25,
        rotate: 0,
        direction: 1,
        speed: 1,
        trail: 60,
        fps: 20,
        zIndex: 2e9,
        top: '50%',
        left: '50%',
        shadow: false,
        hwaccel: false,
        position: 'absolute'
      }}
    />
  );
}

const mapStateToProps = ({ loader }) => {
  return {
    ...loader
  };
};

export default connect(
  mapStateToProps,
  null
)(Loader);
